<template>
    <div>
        <div
            v-if="$device.small"
            class="uk-flex uk-flex-wrap uk-margin-bottom"
        >
            <div
                v-for="(value, field) in list"
                :key="field"
                class="uk-flex-column uk-width-1-1 uk-margin-small-bottom"
            >
                <div>
                    <strong>{{ prettify(field) }}</strong>
                </div>
                <div v-if="field.includes('amount')">
                    ${{ formatPrice(value) }}
                </div>
                <div v-else-if="value">
                    {{ value }}
                </div>
                <div v-else>
                    -
                </div>
            </div>
        </div>
        <table v-else>
            <tr
                v-for="(value, field) in list"
                :key="field"
            >
                <td class="uk-width-1-3 uk-text-small uk-text-bold">
                    {{ prettify(field) }}
                </td>
                <td class="uk-padding-small uk-padding-remove-top uk-padding-remove-bottom">
                    :
                </td>
                <td class="uk-width-expand">
                    <div v-if="field.includes('amount')">
                        ${{ formatPrice(value) }}
                    </div>
                    <div v-else-if="field.includes('date') || field.includes('reminder_sent')">
                        {{ convertUtcDateToLocal(value) }}
                    </div>
                    <div v-else>
                        {{ value }}
                    </div>
                </td>
            </tr>
        </table>
    </div>
</template>

<script>
import { prettify, formatPrice } from  '@strangeanimals/common-vue-components/src/helpers/helpers'
import { convertUtcDateToLocal } from  '../../helpers/helpers'

export default {
    name: 'RefundableDetails',
    props: {
        list: {
            type: [Array, Object],
            required: true,
        }
    },
    methods: {
        prettify(word) {
            return prettify(word);
        },
        formatPrice(price) {
            return formatPrice(price);
        },
        convertUtcDateToLocal(date) {
            let result = convertUtcDateToLocal(date);
            if (!result) {
                result = "N/A";
            }
            return result;
        }
    }
}
</script>
